import React, { Component } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { FiEdit2, FiInfo } from "react-icons/fi";
import { AiOutlineDelete } from "react-icons/ai";
import { Input, TextArea } from '../Ui/Input';
import Radio from '../Ui/Radio';
import DropDown from '../Ui/DropDown';
import Upload from '../Ui/Upload';
import Checkbox from '../Ui/Checkbox';
import Map from '../Ui/Map';
import { DataContainer } from './styles';

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    result.filter(res => res !== null);
    return result;
};

class AddedFields extends Component{

    constructor(props) {
        super(props);
        this.onDragEnd = this.onDragEnd.bind(this);
    }
    
    onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
    
        const data = reorder(
            this.props.formData,
            result.source.index,
            result.destination.index
        );
    
        this.props.reArrangeFieldData(data);
    }

    render(){
        const { formData, isArabic, state, handleEditField, handleRemoveFormField, handleSelectedFiles, selectedFiles, formID } = this.props;
        return(
            <DragDropContext onDragEnd={this.onDragEnd}>
                <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                            {formData.map(({ type, name, label, englishlabel, arabiclabel, method, characterlength, required, englishplaceholder, arabicplaceholder, disabled, options, multiple, dynamic, encrypt, documentvault, category, defaultField }, index) => (
                                <Draggable key={name+'_'+index} draggableId={name+'_'+index} index={index}>
                                    {(provided, snapshot) => (
                                        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                            <DataContainer key={index} isDragging={snapshot.isDragging} >
                                                <p className="mb-0">{index + 1}.</p>
                                                {(type === 'input') ? <Input isArabic={isArabic} maxLength={characterlength} method={method} encrypt={encrypt} label={englishlabel || label} arabiclabel={arabiclabel} required={required} placeholder={englishplaceholder} arabicplaceholder={arabicplaceholder} /> 
                                                    : (type === 'date') ? <Input isArabic={isArabic} label={englishlabel || label} arabiclabel={arabiclabel} type={'date'} required={required} placeholder={englishplaceholder} arabicplaceholder={arabicplaceholder} />
                                                        : (type === 'checkbox') ? <Checkbox isArabic={isArabic} label={englishlabel || label} arabiclabel={arabiclabel} required={required} disabled={disabled} options={options} />
                                                            : (type === 'textarea') ? <TextArea isArabic={isArabic} label={englishlabel || label} arabiclabel={arabiclabel} maxLength={characterlength} type={'text'} required={required} placeholder={englishplaceholder} arabicplaceholder={arabicplaceholder} />
                                                                : (type === 'radio') ? <Radio isArabic={isArabic} label={englishlabel || label} arabiclabel={arabiclabel} required={required} options={options} dynamic={dynamic} />
                                                                    : (type === 'dropdown') ? <DropDown isArabic={isArabic} label={englishlabel || label} arabiclabel={arabiclabel} required={required} value={state[name.replace(/ /g, '').toLowerCase()]} options={options} dynamic={dynamic} placeholder={englishplaceholder} arabicplaceholder={arabicplaceholder} onChange={(value) => this.handleInputChange(name.replace(/ /g, '').toLowerCase(), value.value)} />
                                                                        : (type === 'upload') ? <Upload isArabic={isArabic} label={englishlabel || label} arabiclabel={arabiclabel} required={required} multiple={multiple} documentvault={documentvault} placeholder={englishplaceholder} arabicplaceholder={arabicplaceholder} onChange={handleSelectedFiles} selectedFiles={selectedFiles} category={category} />
                                                                            : (type === 'breakline') ? <hr className="section-divider" />
                                                                                : (type === 'disclaimer') ? <span><FiInfo style={{margin: '-5 0 0 0', color: '#121180', fontSize: '20px'}}/> <i>{isArabic? arabiclabel: englishlabel}</i></span>
                                                                                    : (type === 'map') ? <Map isArabic={isArabic} label={englishlabel || label} arabiclabel={arabiclabel} required={required} placeholder={englishplaceholder} arabicplaceholder={arabicplaceholder} />
                                                                                        : ''}
                                                <div />
                                                {/* {!formID && !defaultField && <> */}
                                                    <FiEdit2 style={{margin: 10,  cursor: 'pointer', fontSize: '20px'}} onClick={() => handleEditField({type, name, englishlabel, arabiclabel, method, characterlength, required, englishplaceholder, arabicplaceholder, options, multiple, dynamic, encrypt, documentvault, category}, index)} />
                                                    <AiOutlineDelete style={{margin: 10,  cursor: 'pointer', fontSize: '20px'}} onClick={() => handleRemoveFormField({type, name})} />
                                                {/* </>} */}
                                            </DataContainer>
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        );
    };
};

export default AddedFields;